import axios from 'axios';
import { auth, endpoints } from '@/config';

export default async function hint(email) {
  const uri = `${endpoints.hint}/${email.toLowerCase()}`;
  const { data } = await axios.get(uri, { headers: { 'x-api-key': auth.hintApiKey } });
  return data;
}
